import { ADMIN_GROUP } from '../constants/services'

export type B2BProductMode = 'STANDARD' | 'B2B_ONLY' | 'SAME_PRICE'

export interface B2BProductSettingDTO {
  _id?: string
  productCode: string
  b2bMode: B2BProductMode
  packageDiscountPercent?: number | null
  palletDiscountPercent?: number | null
  updatedBy?: string | null
  createdAt?: string | Date
  updatedAt?: string | Date
}

export interface UpdateB2BProductModeDTO {
  b2bMode: B2BProductMode
}

export interface ProductPackagingLevelDTO {
  code: string
  quantity: number
  ean: string | null
}

export interface ProductPackagingDTO {
  id_material: string
  nazev: string | null
  unit: string
  salesUnit: string
  salesUnitQuantity: number
  levels: ProductPackagingLevelDTO[]
  package: ProductPackagingLevelDTO | null
  pallet: ProductPackagingLevelDTO | null
  packagingNames: Record<string, string>
  packageDiscountPercent: number | null
  palletDiscountPercent: number | null
  updatedBy?: string | null
  updatedAt?: string | Date
}

export interface UpdateProductPackagingDTO {
  packageQuantity: number | null
  palletQuantity: number | null
  packageDiscountPercent: number | null
  palletDiscountPercent: number | null
}

export const B2B_PRODUCTS_ALLOWED_NAMES = ['sumber', 'šumber', 'toffanin', 'horvath', 'horváth']

export interface B2BProductAccessUser {
  user_id?: number
  user_name?: string
  fullname?: string
  groups?: Array<{ id: number }>
}

export const canManageB2BProducts = (user?: B2BProductAccessUser | null): boolean => {
  if (!user) return false
  const hasAdminGroup = !!user.groups?.some(g => (typeof g === 'object' ? g.id === ADMIN_GROUP : g === ADMIN_GROUP))
  if (hasAdminGroup) return true
  const userNameOrFull = `${user.user_name || ''} ${user.fullname || ''}`.toLowerCase()
  return B2B_PRODUCTS_ALLOWED_NAMES.some(name => userNameOrFull.includes(name))
}
